// extracted by mini-css-extract-plugin
module.exports = {"list-wrapper":"_9e1425b4d3--list-wrapper--rK3cq","button-wrapper":"_9e1425b4d3--button-wrapper--gZEa5","subscribe-form-wrapper":"_9e1425b4d3--subscribe-form-wrapper--U2kz1"};